import React, { Component } from "react";
import DownIcon from "mdi-react/ChevronDownIcon";
import {
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  UncontrolledDropdown,
} from "reactstrap";
import TopbarNavLink from "./TopbarNavLink";

class TopbarNavPages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userPermits: [],
      listTipos: [],
      id_perfil: null,
    };
  }

  componentDidMount() {
    const user = JSON.parse(sessionStorage.getItem("usuario"));    
    this.setState({ id_perfil: user?.id_perfil });

    if (user !== null) {
      if (user.perfil != undefined) {
        var perfil = user.perfil.modulos;
        this.setState({ userPermits: perfil }, () => {});
      } else {
        this.setState({ userPermits: perfil });
      }
    } else {
      this.setState({ userPermits: [] });
    }

    var clinica = JSON.parse(sessionStorage.getItem("clinica"));
    if (clinica !== null && clinica !== undefined) {
      this.setState({ listTipos: clinica.tipo }, () => {
        console.log("listTipos", this.state.listTipos);
      });
    }
  }

  render() {
    return (
      <nav className="topbar__nav">
        <UncontrolledDropdown>
          <DropdownToggle className="topbar__nav-dropdown-toggle">
            Configuración <DownIcon />
          </DropdownToggle>
          <DropdownMenu className="topbar__nav-dropdown-menu dropdown__menu">
            <DropdownItem>
              <TopbarNavLink
                title="Gestión de proveedores"
                route={`${process.env.PUBLIC_URL}/config/proveedores`}
              />
            </DropdownItem>
            {this.state.id_perfil === 9 ? (
              <DropdownItem>
                <TopbarNavLink
                  title="Gestión de usuarios"
                  route={`${process.env.PUBLIC_URL}/config/manage-users`}
                />
              </DropdownItem>
            ) : null}
          </DropdownMenu>
        </UncontrolledDropdown>
      </nav>
    );
  }
}

export default TopbarNavPages;
